<template>
  <div class="news-item-container">
    <div class="row news-item-container-title">
      <span class="news-item-container-title-left">
        <!-- <span class="title" @click="onCheckDetailClick(data.newsId)">{{data.title}}</span> -->
        <a v-if="!data.is_pdf" target="_blank" class="title" :href="data.url">{{data.title}}</a>
        <router-link @click.native="toPdfPage" class="title" v-else target="_blank" :to="{path: '/pdf-detail'}">
          <span>{{data.title}}</span>
        </router-link>
        <span v-if="data.count > 0" @click="onEmitNewsId(data.newsId)" class="related-news"><span class="related-news-icon"></span>相关文章</span>
      </span>
      <div class="row date-source">
        <div class="date">{{data.date}}</div>
        <div class="source">{{data.source}}</div>
      </div>
    </div>
    <div class="summary" v-if="data.summary">
      <div class="summary-content">{{data.summary}}</div>
    </div>
    <sn-news-dialog ref="snNewsDialog"></sn-news-dialog>

    <div class="news-dialog">
      <el-dialog
        :visible.sync="similarityDialogVisible"
        width="814px"
        >
        <div class="news-dialog_title">相关新闻<span class="news-dialog_title-count">({{similarityTotalCount}}条)</span></div>
        <div class="news-list-box">
          <similarity-news-list-item v-for="(item, idx) in similarityResultData" :data="item" :key="idx"></similarity-news-list-item>
          <div class="no-data-container" v-if="!similarityTotalCount">
            <no-data></no-data>
          </div>
        </div>  
      </el-dialog>
    </div>
  </div>
</template>

<script>
import QuestionQuery from '@/rest/questionQuery';
import SimilarityNewsListItem from '@/components/news-monitor/SimilarityNewsListItem';
import SnNewsDialog from '@/components/common/SnNewsDialog';
import localStorageHelper from '@/helpers/localStorageHelper';

export default {
  name: 'news-list-item',
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      similarityDialogVisible: false,
      similarityTotalCount: 0,
      similarityResultData: []
    };
  },
  methods: {
    toPdfPage() {
      localStorageHelper.setItem('PDF_DETAIL_DATA', JSON.stringify(this.data));
    },
    onEmitNewsId(newsId) {
      this.similarityDialogVisible = true;
      QuestionQuery.similarityNewsList(newsId).then(result => {
        this.similarityTotalCount = result.totalCount;
        this.similarityResultData = result.pageItems;
      });
    }
  },
  components: {
    SimilarityNewsListItem,
    SnNewsDialog
  }
};
</script>

<style lang="scss" scoped>
.news-item-container {
  padding: 16px 0;
  box-shadow: inset 0px -1px 0px 0px #f7f7fa;
  .news-item-container-title {
    justify-content: space-between;
    margin-bottom: 10px;
    line-height: 22px;
    .news-item-container-title-left {
      width: 600px;
    }
    .title {
      // display: inline-block;
      margin-right: 16px;
      min-height: 22px;
      color: #171f46;
      font-size: 16px;
      font-weight: normal;
      text-decoration: none;
      cursor: pointer;
      &:hover {
        text-decoration: underline;
      }
    }
    .related-news-icon {
      display: inline-block;
      width: 16px;
      height: 16px;
      margin-right:2px;
      vertical-align: middle;
      background-image: url("../../assets/img/related-news.svg");
      background-size: cover;
    }
    .related-news {
      font-size: 12px;
      color: #45a8cc;
      cursor: pointer;
      &:hover {
        color:#3cbeed;
        font-weight: bold;
      }
      &:active {
        color: #45a8cc;
        font-weight: bold;
      }
    }
    .date-source {
      margin-left: 20px;
      color: #747990;
      font-size: 12px;
      .source {
        margin-left: 16px;
        max-width: 108px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
  .summary {
    .summary-content {
      word-break: break-all;
      color: #747990;
      font-size: 12px;
      letter-spacing: 0.3px;
    }
  }
  .tag-name {
    margin-right: 10px;
    font-size: 12px;
  }
  .positive {
    color: #ff5b65;
  }
  .negative {
    color: #54cea4;
  }
  .neutral {
    color: #ffffff;
  }
}
/deep/.detail-dialog {
  .detail-dialog-header {
    padding: 32px 32px 24px;
    min-height: 110px;
    width: 100%;
    box-shadow: inset 0px -1px 0px 0px#4f4e55;
    .title {
      margin-bottom: 10px;
      color: #ffffff;
      font-size: 20px;
      font-weight: 500;
    }
    .dialog-date-source {
      justify-content: space-between;
      color: rgba(255, 255, 255, 0.7);
      font-size: 12px;
      font-weight: 500;
      .source {
        margin-left: 16px;
      }
    }
  }
  .detail-dialog-content {
    padding: 24px 32px;
    height: 496px;
    overflow: auto;
    color: #ffffff;
    font-size:14px;
    line-height: 22px;
    box-shadow: inset 0px -1px 0px 0px#4f4e55;
  }
  .detail-dialog-footer {
    padding: 16px 32px;
    .url {
      color: #45a8cc;
      font-size: 14px;
      font-weight: 500;
      text-decoration: none;
    }
    .warning {
      margin-top: 4px;
      color: rgba(255, 255, 255, 0.7);
      font-size: 12px;
    }
  }
  .el-dialog {
    background-color: #333138;
    .el-dialog__header {
      padding: 0;
    }
    .el-dialog__body {
      min-height: 680px;
      padding: 0;
    }
    .el-dialog__footer {
      padding: 0px;
    }
  }
}
/deep/{
  .el-switch__core {
    width: 34px !important;
  }
  .el-switch__core:after {
    top: 3px;
    left: 3px;
    width: 12px;
    height: 12px;
    background-color: #e4e4e4;
  }
  .el-switch.is-checked .el-switch__core::after {
    margin-left: -14px;
  }
}

.news-dialog {
  &_title {
    height: 44px;
    line-height: 44px;
    padding-left: 24px;
    font-size: 14px;
    color: #171F46;
    box-shadow:0px 1px 0px 0px rgba(247,247,250,1);
  }
  .news-list-box {
    height: 656px;
    overflow-y: auto;
    .no-data-container {
      height: 500px;
    }
  }
  /deep/ .el-dialog__wrapper {
    // z-index: 9999 !important;
    background: rgba(0,0,0,0.4);
    .el-dialog {
      width: 900px;
      position: relative;
      margin-top: 13vh !important;
      border-radius: 8px;
      border: solid 1px #3e393b;
      .el-dialog__header {
        position: absolute;
        top: 0;
        right: 0px;
        .el-dialog__headerbtn {
          width: 24px;
          height: 24px;
          top: 12px;
          .el-dialog__close {
            color: #514d4f;
          }
        }
      }
      .el-dialog__body {
        background: #ffffff;
        padding: 0;
        .search-news-list-container {
          .filter {
            height: 54px;
            justify-content: center;
            span {
              display: none;
            }
            div{
              display: none;
            }
            border-bottom: 1px solid #4E4A4D;
            padding-bottom: 22px;
          }
          .result-container {
          height: 60vh;
          overflow-y: auto;
          margin-top: 0;
          // &::-webkit-scrollbar-track-piece {
          //   background-color: rgba(0, 0, 0, 0);
          //   border-left: 1px solid rgba(0, 0, 0, 0);
          // }
          // &::-webkit-scrollbar {
          //   width: 8px;
          //   height: 34px;
          // }
          // &::-webkit-scrollbar-thumb {
          //   background-color: #676366;
          //   background-clip: padding-box;
          //   min-height: 28px;
          // }
          // &::-webkit-scrollbar-thumb:hover {
          //   background-color: #999999;
          // }
            .news-list-header {
              display: none;
            }
          }
        }
      }
    }
  }
}
</style>

